import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React, { useContext, useState } from "react";

import {
  Context,
  fetchPulseSurveyQuestionsWithAnswers,
} from "../../../store/student";
import FabButton from "../../../atoms/FabButton";
import FiltableHeader from "../../../organisms/FiltableHeader";
import RealizationPulseSurvey from "../../../templates/RealizationPulseSurvey";
import styles from "../common.module.scss";

const RealizationPulseSurveyPage = () => {
  const { dispatch } = useContext(Context);

  useIonViewWillEnter(() => {
    dispatch(fetchPulseSurveyQuestionsWithAnswers());
  });

  const [state, setState] = useState({
    searching: false,
    searchText: "",
  });

  return (
    <IonPage>
      <FiltableHeader
        title="デイリーストック"
        unreadNotiCount={0}
        searching={state.searching}
        searchText={state.searchText}
        setState={setState}
        goBack
      />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <RealizationPulseSurvey state={state} />
        </div>
      </IonContent>
      <FabButton />
    </IonPage>
  );
};

export default RealizationPulseSurveyPage;
